import React from "react"

import "./greeting.scss"

export class ContactGreeting extends React.Component {
  constructor( props ) {
    super( props )
    this.state = { now: new Date() }
    this.tick = this.tick.bind( this )
  }

  componentDidMount() {
    this.timer = setInterval( this.tick, 60000 )
  }

  componentWillUnmount() {
    clearInterval( this.timer )
  }

  tick() {
    this.setState( { now: new Date() } )
  }

  render() {
    const { language } = this.props
    let content = ""

    if( language === "en" ) {
      content = "SP " + ( this.state.now ).toLocaleString( 'en-US', { hour: '2-digit', minute: '2-digit', timeZone: "America/Sao_Paulo" } )
    } else {
      content = "Olá"
    }
    return (
      <div className={ `greeting ${ language }` } >
        { content }
      </div>
    )
  }
}

